import { usePaidBreakExceptionStore } from '#/shared/stores/paidBreakExceptionStore';
import { PaidBreakExceptionFormValue } from '#/shared/types/PaidBreakRequest';

/**
 * Transforms store exceptions to form values for submission.
 * Only includes exceptions that have been decided (accepted or rejected).
 * @returns Array of PaidBreakExceptionFormValue
 */
export const mapPaidBreakExceptionToPaidBreakExceptionFormValue = (): PaidBreakExceptionFormValue[] => {
  const exceptions = usePaidBreakExceptionStore.getState().exceptions;
  const formValues: PaidBreakExceptionFormValue[] = [];

  Object.entries(exceptions).forEach(([dateString, exception]) => {
    if (exception && (exception.approverDecision === 'accepted' || exception.approverDecision === 'rejected')) {
      formValues.push({
        shift_date: dateString,
        approver_decision: exception.approverDecision,
        approver_notes: exception.approverNotes,
      });
    }
  });

  return formValues;
};
